import { useAuth } from '../contexts/AuthContext';

/**
 * For vessel accounts (`typeLocation === 'VESSEL'`), returns the linked vessel id for scoping list queries.
 * Office/supplier users get `null`.
 * Uses `vesselId` first, then `vessel.id` from `/profile` when the FK is present only on the relation.
 */
export function useAccountVesselScope(): number | null {
  const { user } = useAuth();
  if (!user) return null;

  const loc = user.typeLocation != null ? String(user.typeLocation).toUpperCase() : '';
  if (loc !== 'VESSEL') return null;

  if (user.vesselId != null) {
    const n = Number(user.vesselId);
    if (Number.isFinite(n) && n > 0) return n;
  }
  if (user.vessel?.id != null) {
    const n = Number(user.vessel.id);
    if (Number.isFinite(n) && n > 0) return n;
  }
  return null;
}
